import kpnFoto from '../assets/KPN-logo-vierkant.jpeg';

const IsraCard = (props) => {
  return (
    <div className='questionBox'>
      <div className='foto-box '>
        <div className='foto'>
          <img src={kpnFoto} alt='#' />
        </div>
        <div className='foto-text table-container'>
          <h2 className='text-center'>{props.item.title}</h2>
          <p>{props.item.description}</p>
        </div>
      </div>
    </div>
  );
};

export default IsraCard;
